import React from "react";

/**
 * Filters (Dashboard Magasin)
 * ==========================
 * Props attendues:
 * - filterType, setFilterType        (API)
 * - filterStatus, setFilterStatus    (API)
 *
 * ✅ Nouveaux filtres front (optionnels):
 * - viewMode, setViewMode            (front)
 * - readySort, setReadySort          (front)
 */

const Filters = ({
  // API filters (existants)
  filterType,
  setFilterType,
  filterStatus,
  setFilterStatus,

  // Front filters (optionnels)
  viewMode,
  setViewMode,
  readySort,
  setReadySort,
}) => {
  const hasView = typeof setViewMode === "function";
  const hasReadySort = typeof setReadySort === "function";

  return (
    <div
      className="mdx-filters"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 10,
      }}
    >
      {/* LEFT */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {/* TYPE */}
        <select
          value={filterType || "pickpay"}
          onChange={(e) => setFilterType?.(e.target.value)}
          className="border p-2 rounded"
          style={{ height: 38 }}
          aria-label="Filtrer par type"
        >
          <option value="pickpay">Pick &amp; Pay</option>
          <option value="livraison">Livraison</option>
          <option value="all">Tous</option>
        </select>

        {/* STATUS (API) */}
        <select
          value={filterStatus || ""}
          onChange={(e) => setFilterStatus?.(e.target.value)}
          className="border p-2 rounded"
          style={{ height: 38 }}
          aria-label="Filtrer par statut"
        >
          <option value="">Tous les statuts (API)</option>

          {/* Statut de base */}
          <option value="paid">Payé</option>

          {/* Prêtes */}
          <option value="ready_for_pick">Prête (Pick)</option>
          <option value="ready_for_delivery">Prête (Livraison)</option>

          {/* Autres (si tu les utilises côté DB) */}
          <option value="in_preparation">En préparation</option>
          <option value="packed">Emballée</option>
          <option value="out_for_delivery">En livraison</option>
          <option value="delivered">Livrée</option>
          <option value="cancelled">Annulée</option>

          {/* Debug / historique */}
          <option value="PENDING_PAYMENT">Paiement en attente</option>
        </select>

        {/* VIEW MODE (front) */}
        {hasView ? (
          <select
            value={viewMode || "all"}
            onChange={(e) => setViewMode(e.target.value)}
            className="border p-2 rounded"
            style={{ height: 38 }}
            aria-label="Vue"
            title="Filtre d’affichage (front)"
          >
            <option value="all">Vue : Tout</option>
            <option value="pending">Vue : À préparer</option>
            <option value="ready">Vue : Prêtes</option>
          </select>
        ) : null}
      </div>

      {/* RIGHT */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {/* READY SORT (front) */}
        {hasReadySort ? (
          <select
            value={readySort || "fifo"}
            onChange={(e) => setReadySort(e.target.value)}
            className="border p-2 rounded"
            style={{ height: 38 }}
            aria-label="Tri des commandes prêtes"
            title="Tri appliqué uniquement à la colonne Prêtes"
          >
            <option value="fifo">Prêtes : Ancien → Récent</option>
            <option value="lifo">Prêtes : Récent → Ancien</option>
          </select>
        ) : null}
      </div>
    </div>
  );
};

export default Filters;
